import { ApiErrorMap } from '../models/api-error-maps/api-error-map';
import { fleetErrorMap } from '../models/api-error-maps/fleet-error-map';
import { routingProfileErrorMap } from '../models/api-error-maps/routing-profile-error-map';
import { Apis } from '../models/apis';

const errorMap = new Map<Apis, ApiErrorMap>([
  ['fleet', fleetErrorMap],
  ['routingProfiles', routingProfileErrorMap],
]);

/**
 * Lookup corresponding transloco key for standard api errorCode per api
 * @param api string key for api error map lookup
 * @param errorCode numeric errorCode from the response (usually a negative number). If undefined, returns generic unknown error
 * @returns a transloco string key for the appropriate errorCode
 */
export function getStandardErrorMessageKey(api: Apis, errorCode?: number) {
  const genericUnknownError = 'errors.generic.unknownError';
  const apiErrorMap = errorMap.get(api);

  if (apiErrorMap && typeof errorCode !== 'undefined') {
    return apiErrorMap.get(errorCode) ?? genericUnknownError;
  }

  return genericUnknownError;
}

/**
 * t(errors.generic.unknownError)
 */
